//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SubscribeGuide from '../_components/_subscribe_guide'
import SubscribeSuccess from '../_components/_subscribe_success'

import { C_MP_SERVICE } from '@/constant'
import Service from '@/service/public'
import { openChat } from '@/data/im'
import { App_User, GLOBAL_USER_DATA } from '@/data/user_info'

export default {
    components: {
        SubscribeGuide,
        SubscribeSuccess
    },
    props: {
        favourite: Boolean,
        add_group_url: String
    },
    data () {
        return {
            weixin_phone_number: '',
            weixin_subscribed: false,
            is_vip: false,
            show: false
        }
    },
    mounted() {
    },
    methods: {
        async checkLogging () {
            App_User.get().then((data) => {
                if (data.tag_list[0] == "天府通游客") {
                    wx.navigateTo({
                        url: '/logging_in'
                    })
                    return
                } else {
                    this.$emit('finally')
                }
            })
        },
        closePopup () {
            this.show = false
        },
        subscribe () {
            wx.navigateTo({
                url: `/web_page?link=${encodeURIComponent(C_MP_SERVICE.link)}&title=${C_MP_SERVICE.name}`
            })
            this.$sendCtmEvtLog('关注楼盘弹窗点击关注服务号')
            this.closePopup()
        },
        async consult () {
            const { building_id } = this.$route.query
            const consultant = await Service.getRecommendConsultant({
                scene: 'building_online_consultation',
                building_id
            })
            if (!consultant || !consultant.id) {
                wx.navigateTo({
                    url: `/building/discuess_group/main?link=${this.add_group_url}`
                })
            } else {
                openChat(consultant.id, {
                    building_id,
                    log_name: '关注楼盘弹窗点击在线咨询'
                })
            }
            this.closePopup()
        }
    }
}
